import {
  recommenderRecipesAtom,
  recommenderMealplanAtom,
} from 'dataLayer/recoil/apiData/atoms';
import { selector } from 'recoil';
import {
  parseRecipesForRendering,
  filterRecipesByTags,
  filterMealsByTags,
} from 'dataLayer/recoil/pages/helpers/recommenderHelper';

const getRecipeSelector = (selectorKey, tag) => {
  return {
    key: selectorKey,
    get: ({ get }) => {
      let recipeRoutines = [];

      let recommenderRecipes = get(recommenderRecipesAtom);
      const recipes = filterRecipesByTags(recommenderRecipes, tag);
      recipeRoutines = parseRecipesForRendering(recipes);

      return recipeRoutines;
    },
  };
};

const getMealplanSelector = (selectorKey, tag) => {
  return {
    key: selectorKey,
    get: ({ get }) => {
      let recipeRoutines = [];

      let recommenderMealplan = get(recommenderMealplanAtom);
      const recipes = filterMealsByTags(recommenderMealplan, tag);
      recipeRoutines = parseRecipesForRendering(recipes);

      return recipeRoutines;
    },
  };
};

export const recipeRoutineBreakfastSelector = selector(
  getRecipeSelector(
    'pages/stayActive/selectors/recipeRoutineBreakfast',
    'breakfast'
  )
);

export const mealplanRoutineBreakfastSelector = selector(
  getMealplanSelector(
    'pages/stayActive/selectors/mealplanRoutineBreakfast',
    'breakfast'
  )
);

export const recipeRoutineLunchSelector = selector(
  getRecipeSelector('pages/stayActive/selectors/recipeRoutineLunch', 'lunch')
);

export const mealplanRoutineLunchSelector = selector(
  getMealplanSelector(
    'pages/stayActive/selectors/mealplanRoutineLunch',
    'lunch'
  )
);

export const recipeRoutineDinnerSelector = selector(
  getRecipeSelector('pages/stayActive/selectors/recipeRoutineDinner', 'dinner')
);

export const mealplanRoutineDinnerSelector = selector(
  getMealplanSelector(
    'pages/stayActive/selectors/mealplanRoutineDinner',
    'dinner'
  )
);
